import { Button } from '@ifood/pomodoro-components';
import { ChevronUp } from '@ifood/pomodoro-icons';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import { FOOTER_CALLOUT_CONFIG } from 'modules/Home/constants';
import { Link } from 'modules/UI';

import { ActionLink, Actions, Container, Filler, Limiter, Title } from './styles';

const scrollToTop = (): void => scroll.scrollTo(0, { behavior: 'smooth' });

const FooterCallOut: FC = () => {
  return (
    <Container>
      <Limiter>
        <Title>
          <FormattedMessage id={FOOTER_CALLOUT_CONFIG.titleKey} />
        </Title>
        <Actions>
          <Filler />
          <Link dataTestId={`footer-callout-link`} href={FOOTER_CALLOUT_CONFIG.link} noStyles>
            <Button tabIndex={-1}>
              <FormattedMessage id={FOOTER_CALLOUT_CONFIG.linkKey} />
            </Button>
          </Link>
          <ActionLink noStyles dataTestId="footer-go-back-to-the-top" onClick={scrollToTop}>
            <FormattedMessage id="back-to-the-top" />
            <ChevronUp width={24} height={24} />
          </ActionLink>
        </Actions>
      </Limiter>
    </Container>
  );
};

export default FooterCallOut;
